import React from "react";
import Icon from "@ant-design/icons";
import "./styles.scss"

const ProfileDotsIcon = () => (
  <svg
    width="16"
    height="4"
    viewBox="0 0 18 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.62476 1.62494H9.37476M8.62476 2.37494H9.37476M1.62476 1.62494H2.37476M1.62476 2.37494H2.37476M15.6248 1.62494H16.3748M15.6248 2.37494H16.3748M10 2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2C8 1.44772 8.44772 1 9 1C9.55228 1 10 1.44772 10 2ZM3 2C3 2.55228 2.55229 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55229 1 3 1.44772 3 2ZM17 2C17 2.55228 16.5523 3 16 3C15.4477 3 15 2.55228 15 2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const SearchIcon = (props) => (
  <svg
    fill="rgba(0,0,0,0.6)"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" />
  </svg>
);

const ProfileDots = (props) => <Icon component={ProfileDotsIcon} {...props} />;

const SmartRosterPinnedIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 14.6666L2.75 19.2499M3.00927 9.42584L12.5741 18.9906C12.6809 19.0975 12.8638 19.0365 12.8852 18.8869L13.6636 13.4382C13.7197 13.0455 13.9016 12.6816 14.1821 12.4011L16.1409 10.4423C16.3759 10.2073 16.6703 10.0407 16.9926 9.96007L19.3813 9.3629C19.727 9.27649 19.8462 8.84607 19.5943 8.59416L13.4057 2.40564C13.1538 2.15372 12.7234 2.27294 12.637 2.61857L12.0398 5.00726C11.9592 5.32962 11.7926 5.62401 11.5576 5.85897L9.59879 7.81778C9.31829 8.09827 8.95439 8.28022 8.5617 8.33632L3.11298 9.11471C2.96342 9.13608 2.90245 9.31901 3.00927 9.42584Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterPinned = (props) => (
  <Icon component={SmartRosterPinnedIcon} {...props} />
);

const SmartRosterClearIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07115 13.0834C1.91561 12.4141 1.83337 11.7167 1.83337 11C1.83337 10.2834 1.91561 9.586 2.07115 8.91671M9.33337 1.98452C9.87383 1.88525 10.4309 1.83337 11 1.83337C16.0627 1.83337 20.1667 5.93743 20.1667 11C20.1667 16.0627 16.0627 20.1667 11 20.1667C10.4309 20.1667 9.87383 20.1148 9.33337 20.0156M6.41671 3.05971C5.1664 3.78298 4.10277 4.79308 3.31582 6.00004M3.31582 16C4.10277 17.207 5.1664 18.2171 6.41671 18.9404M13.75 9.16671L10.1437 12.773C10.1097 12.807 10.0552 12.809 10.0189 12.7775L8.25004 11.245"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterTaskCenter = (props) => (
  <Icon component={SmartRosterClearIcon} {...props} />
);

const SmartRosterActivityIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 11H5.14214C5.35246 11 5.53578 10.8569 5.58679 10.6528L6.88869 5.44525C7.00441 4.98236 7.66226 4.98236 7.77798 5.44526L10.5554 16.5547C10.6711 17.0176 11.3289 17.0176 11.4446 16.5547L12.7465 11.3472C12.7975 11.1431 12.9809 11 13.1912 11H20.1667"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterActivity = (props) => (
  <Icon component={SmartRosterActivityIcon} {...props} />
);

const SmartRosterDashboardIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 18.25L7.25 1.75M1.75 18.25L1.75 13.6667M12.75 18.25L12.75 5.41667M18.25 18.25V10"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterDashboard = (props) => (
  <Icon {...props} component={SmartRosterDashboardIcon} />
);

const SmartRosterAddIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7.33334V11M11 11V14.6667M11 11H14.6666M11 11H7.33331M20.1666 11C20.1666 16.0626 16.0626 20.1667 11 20.1667C5.93737 20.1667 1.83331 16.0626 1.83331 11C1.83331 5.93739 5.93737 1.83334 11 1.83334C16.0626 1.83334 20.1666 5.93739 20.1666 11Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterAdd = (props) => (
  <Icon {...props} component={SmartRosterAddIcon} />
);

export const SmartRosterCheck = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 8.16667L8.14368 11.773C8.10968 11.807 8.05518 11.8089 8.01884 11.7775L6.25 10.2449M1.97819 4.88743L8.08342 1.36257C8.65066 1.03508 9.34952 1.03508 9.91676 1.36257L16.022 4.88743C16.5892 5.21492 16.9387 5.82016 16.9387 6.47514V13.5249C16.9387 14.1798 16.5892 14.7851 16.022 15.1126L9.91676 18.6374C9.34952 18.9649 8.65066 18.9649 8.08342 18.6374L1.97819 15.1126C1.41096 14.7851 1.06152 14.1798 1.06152 13.5249V6.47514C1.06152 5.82016 1.41096 5.21492 1.97819 4.88743Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterNewmanTanks = (props) => (
  <Icon {...props} component={SmartRosterCheck} />
);

const SmartRosterBHPIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1396_1363)">
      <path
        d="M2.75 19.25H3.66667M19.25 19.25H18.3333M3.66667 19.25V7.94444C3.66667 7.5315 3.66667 7.32502 3.69705 7.1527C3.84305 6.32468 4.49135 5.67639 5.31937 5.53038C5.49169 5.5 5.69816 5.5 6.11111 5.5V5.5C6.31759 5.5 6.42082 5.5 6.50698 5.48481C6.92099 5.41181 7.24514 5.08766 7.31814 4.67365C7.33333 4.58749 7.33333 4.48425 7.33333 4.27778V4.27778C7.33333 3.86483 7.33333 3.65836 7.36372 3.48604C7.50972 2.65801 8.15801 2.00972 8.98604 1.86372C9.15836 1.83333 9.36483 1.83333 9.77778 1.83333L11.4667 1.83333C12.5868 1.83333 13.1468 1.83333 13.5746 2.05132C13.951 2.24307 14.2569 2.54903 14.4487 2.92535C14.6667 3.35318 14.6667 3.91323 14.6667 5.03333V7.33333M3.66667 19.25H14.6667M14.6667 19.25V7.33333M14.6667 19.25H18.3333M14.6667 7.33333H16.7333C17.2934 7.33333 17.5734 7.33333 17.7873 7.44233C17.9755 7.5382 18.1285 7.69118 18.2243 7.87934C18.3333 8.09325 18.3333 8.37328 18.3333 8.93333V19.25"
        stroke="#68727D"
        strokeWidth="2"
        strokeLinecap="round"
        shape-rendering="crispEdges"
      />
    </g>
  </svg>
);
const SmartRosterBHP = (props) => (
  <Icon {...props} component={SmartRosterBHPIcon} />
);

const SmartRosterPersonelIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 13.2917C14.1641 13.2917 16.7291 10.7266 16.7291 7.5625C16.7291 4.39837 14.1641 1.83334 11 1.83334C7.83585 1.83334 5.27081 4.39837 5.27081 7.5625C5.27081 10.7266 7.83585 13.2917 11 13.2917ZM11 13.2917C5.93737 13.2917 1.83331 16.3697 1.83331 20.1667M11 13.2917C16.0626 13.2917 20.1666 16.3697 20.1666 20.1667"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterPersonnel = (props) => (
  <Icon {...props} component={SmartRosterPersonelIcon} />
);

const SmartRosterFlightsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3334 1.66667L6.89769 10.3639C6.80355 10.4506 6.74999 10.5728 6.74999 10.7009V16.011C6.74999 16.4365 7.2794 16.6324 7.55632 16.3093L11.25 12M1.81356 8.46822L16.5644 1.09283C16.8744 0.937809 17.2376 1.16977 17.2275 1.51625L16.8922 12.9146C16.8835 13.2122 16.5977 13.4226 16.3109 13.3426L1.89533 9.31963C1.49138 9.2069 1.43845 8.65578 1.81356 8.46822Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterFlights = (props) => (
  <Icon component={SmartRosterFlightsIcon} {...props} />
);

const SmartRosterAccomodationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66665 8.16667V8.16667C1.84974 8.16667 1.3376 7.28416 1.7429 6.57489L3.57863 3.36236C3.9142 2.77512 4.08198 2.4815 4.31774 2.26789C4.52633 2.07889 4.77246 1.93605 5.04005 1.84871C5.34249 1.75 5.68066 1.75 6.35701 1.75H8.16665M2.66665 8.16667V15.05C2.66665 16.1701 2.66665 16.7302 2.88463 17.158C3.07638 17.5343 3.38234 17.8403 3.75867 18.032C4.18649 18.25 4.74654 18.25 5.86665 18.25H9.99998M2.66665 8.16667H6.33331M17.3333 8.16667V8.16667C18.1502 8.16667 18.6624 7.28416 18.2571 6.57489L16.4213 3.36236C16.0858 2.77512 15.918 2.4815 15.6822 2.26789C15.4736 2.07889 15.2275 1.93605 14.9599 1.84871C14.6575 1.75 14.3193 1.75 13.6429 1.75H11.8333M17.3333 8.16667V15.05C17.3333 16.1701 17.3333 16.7302 17.1153 17.158C16.9236 17.5343 16.6176 17.8403 16.2413 18.032C15.8135 18.25 15.2534 18.25 14.1333 18.25H13.6666M17.3333 8.16667H13.6666M13.6666 18.25H9.99998M13.6666 18.25V13.4333C13.6666 12.8733 13.6666 12.5933 13.5577 12.3793C13.4618 12.1912 13.3088 12.0382 13.1206 11.9423C12.9067 11.8333 12.6267 11.8333 12.0666 11.8333H11.6C11.0399 11.8333 10.7599 11.8333 10.546 11.9423C10.3578 12.0382 10.2048 12.1912 10.109 12.3793C9.99998 12.5933 9.99998 12.8733 9.99998 13.4333V18.25M6.33331 11.8333V11.8425M6.33331 8.16667H9.99998H13.6666M6.33331 8.16667L8.16665 1.75M8.16665 1.75H11.8333M11.8333 1.75L13.6666 8.16667"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const MettingAccomodation = (props) => (
  <Icon {...props} component={SmartRosterAccomodationIcon} />
);

const SmartRosterReportsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1666 17.3333C20.7189 17.3333 21.1666 16.8856 21.1666 16.3333C21.1666 15.781 20.7189 15.3333 20.1666 15.3333V17.3333ZM2.83331 1.66666C2.83331 1.11437 2.3856 0.666656 1.83331 0.666656C1.28103 0.666656 0.833313 1.11437 0.833313 1.66666H2.83331ZM3.83535 15.9337L4.28934 15.0427H4.28934L3.83535 15.9337ZM2.23296 14.3313L1.34195 14.7853L2.23296 14.3313ZM10.4074 6.57408L11.1145 5.86697L10.4074 6.57408ZM13.4259 9.59257L12.7188 10.2997L13.4259 9.59257ZM14.0741 9.59257L14.7812 10.2997L14.7812 10.2997L14.0741 9.59257ZM19.9571 5.12376C20.3476 4.73324 20.3476 4.10007 19.9571 3.70955C19.5666 3.31903 18.9334 3.31903 18.5429 3.70955L19.9571 5.12376ZM4.79287 10.1262C4.40235 10.5167 4.40235 11.1499 4.79287 11.5404C5.1834 11.931 5.81656 11.931 6.20709 11.5404L4.79287 10.1262ZM9.75922 6.57408L10.4663 7.28119L9.75922 6.57408ZM20.1666 15.3333H7.69998V17.3333H20.1666V15.3333ZM2.83331 10.4667V1.66666H0.833313V10.4667H2.83331ZM7.69998 15.3333C6.65672 15.3333 5.93441 15.3325 5.37315 15.2867C4.82357 15.2418 4.51704 15.1587 4.28934 15.0427L3.38136 16.8247C3.938 17.1083 4.53702 17.225 5.21029 17.28C5.87188 17.3341 6.68972 17.3333 7.69998 17.3333V15.3333ZM0.833313 10.4667C0.833313 11.4769 0.832535 12.2948 0.886589 12.9563C0.941597 13.6296 1.05833 14.2286 1.34195 14.7853L3.12396 13.8773C3.00794 13.6496 2.92485 13.3431 2.87995 12.7935C2.83409 12.2322 2.83331 11.5099 2.83331 10.4667H0.833313ZM4.28934 15.0427C3.78757 14.787 3.37962 14.3791 3.12396 13.8773L1.34195 14.7853C1.78936 15.6634 2.50327 16.3773 3.38136 16.8247L4.28934 15.0427ZM9.7003 7.28119L12.7188 10.2997L14.133 8.88546L11.1145 5.86697L9.7003 7.28119ZM14.7812 10.2997L19.9571 5.12376L18.5429 3.70955L13.367 8.88546L14.7812 10.2997ZM6.20709 11.5404L10.4663 7.28119L9.05212 5.86697L4.79287 10.1262L6.20709 11.5404ZM12.7188 10.2997C13.2883 10.8692 14.2117 10.8692 14.7812 10.2997L13.367 8.88546C13.5785 8.67393 13.9215 8.67392 14.133 8.88546L12.7188 10.2997ZM11.1145 5.86697C10.545 5.29746 9.62163 5.29746 9.05212 5.86697L10.4663 7.28119C10.2548 7.49272 9.91183 7.49272 9.7003 7.28119L11.1145 5.86697Z"
      fill="#68727D"
    />
  </svg>
);
const SmartRosterReports = (props) => (
  <Icon {...props} component={SmartRosterReportsIcon} />
);

const SmartRosterSettingIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.32269 2.23952H3.01019M2.32269 2.92702H3.01019M8.16667 2.58332H18.25M2.32269 8.65618H3.01019M2.32269 9.34368H3.01019M2.32269 15.0729H3.01019M2.32269 15.7604H3.01019M8.16667 8.99999H18.25M8.16667 15.4167H18.25M3.58333 2.58332C3.58333 3.08958 3.17293 3.49999 2.66667 3.49999C2.16041 3.49999 1.75 3.08958 1.75 2.58332C1.75 2.07706 2.16041 1.66666 2.66667 1.66666C3.17293 1.66666 3.58333 2.07706 3.58333 2.58332ZM3.58333 8.99999C3.58333 9.50625 3.17293 9.91666 2.66667 9.91666C2.16041 9.91666 1.75 9.50625 1.75 8.99999C1.75 8.49373 2.16041 8.08332 2.66667 8.08332C3.17293 8.08332 3.58333 8.49373 3.58333 8.99999ZM3.58333 15.4167C3.58333 15.9229 3.17293 16.3333 2.66667 16.3333C2.16041 16.3333 1.75 15.9229 1.75 15.4167C1.75 14.9104 2.16041 14.5 2.66667 14.5C3.17293 14.5 3.58333 14.9104 3.58333 15.4167Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterSetting = (props) => (
  <Icon {...props} component={SmartRosterSettingIcon} />
);

const SmartRosterManagementIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0001 14.4375C13.215 14.4375 15.0105 12.642 15.0105 10.4271C15.0105 8.2122 13.215 6.41668 11.0001 6.41668C8.7852 6.41668 6.98967 8.2122 6.98967 10.4271C6.98967 12.642 8.7852 14.4375 11.0001 14.4375ZM11.0001 14.4375C8.66588 14.4375 6.62278 15.3723 5.49998 16.7699M11.0001 14.4375C13.3343 14.4375 15.3774 15.3723 16.5002 16.7699M6.50152 1.83334H15.4984C15.8266 1.83334 16.0926 2.10119 16.0926 2.4316C16.0926 4.08364 17.4226 5.42288 19.0633 5.42288H19.4876C19.8626 5.42288 20.1666 5.72899 20.1666 6.1066V6.98717C20.1666 12.6681 17.1079 17.9026 12.176 20.6615L11.7908 20.877C11.299 21.1521 10.701 21.1521 10.2092 20.877L9.82393 20.6615C4.89206 17.9026 1.83331 12.6681 1.83331 6.98717V6.1066C1.83331 5.72899 2.13732 5.42288 2.51233 5.42288H2.93671C4.57737 5.42288 5.90739 4.08364 5.90739 2.4316C5.90739 2.10119 6.17339 1.83334 6.50152 1.83334Z"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterManagement = (props) => (
  <Icon {...props} component={SmartRosterManagementIcon} />
);

const SmartRosterDataIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3334 3.58331C16.3334 5.1021 13.0501 6.33331 9.00002 6.33331C4.94993 6.33331 1.66669 5.1021 1.66669 3.58331M16.3334 3.58331C16.3334 2.06453 13.0501 0.833313 9.00002 0.833313C4.94993 0.833313 1.66669 2.06453 1.66669 3.58331M16.3334 3.58331V16.4166C16.3334 17.9354 13.0501 19.1666 9.00002 19.1666C4.94993 19.1666 1.66669 17.9354 1.66669 16.4166V3.58331M16.3334 9.99998C16.3334 11.5188 13.0501 12.75 9.00002 12.75C4.94993 12.75 1.66669 11.5188 1.66669 9.99998"
      stroke="#68727D"
      strokeWidth="1.67"
    />
  </svg>
);
const SmartRosterData = (props) => (
  <Icon {...props} component={SmartRosterDataIcon} />
);

const SmartRosterArrowsIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1L1.70711 6.29289C1.31658 6.68342 1.31658 7.31658 1.70711 7.70711L7 13M13 1L7.70711 6.29289C7.31658 6.68342 7.31658 7.31658 7.70711 7.70711L13 13"
      stroke="#68727D"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterArrows = (props) => (
  <Icon {...props} component={SmartRosterArrowsIcon} />
);

const LogoutIcon = (props) => (
  <svg
    width={19}
    height={17}
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8333 4.33333C4.8333 4.88562 5.28101 5.33333 5.8333 5.33333C6.38558 5.33333 6.8333 4.88562 6.8333 4.33333H4.8333ZM6.8333 12.6667C6.8333 12.1144 6.38558 11.6667 5.8333 11.6667C5.28101 11.6667 4.8333 12.1144 4.8333 12.6667H6.8333ZM6.74331 15.8183L7.1973 14.9273L7.1973 14.9273L6.74331 15.8183ZM6.01495 15.09L5.12394 15.544L5.12394 15.544L6.01495 15.09ZM17.3183 15.09L18.2093 15.544V15.544L17.3183 15.09ZM16.5899 15.8183L16.136 14.9273L16.136 14.9273L16.5899 15.8183ZM16.5899 1.18166L16.136 2.07266L16.136 2.07266L16.5899 1.18166ZM17.3183 1.91002L16.4273 2.36401V2.36401L17.3183 1.91002ZM6.01495 1.91002L6.90596 2.36401V2.36401L6.01495 1.91002ZM6.74331 1.18166L6.28932 0.290649V0.290649L6.74331 1.18166ZM11.6666 9.5C12.2189 9.5 12.6666 9.05228 12.6666 8.5C12.6666 7.94772 12.2189 7.5 11.6666 7.5V9.5ZM2.49996 7.5C1.94768 7.5 1.49996 7.94772 1.49996 8.5C1.49996 9.05228 1.94768 9.5 2.49996 9.5V7.5ZM4.16535 6.5547C4.4717 6.09517 4.34752 5.4743 3.888 5.16795C3.42847 4.8616 2.8076 4.98577 2.50124 5.4453L4.16535 6.5547ZM1.82071 8.26888L2.65276 8.82358H2.65276L1.82071 8.26888ZM1.82071 8.73113L2.65276 8.17642L1.82071 8.73113ZM2.50124 11.5547C2.8076 12.0142 3.42847 12.1384 3.888 11.8321C4.34752 11.5257 4.4717 10.9048 4.16535 10.4453L2.50124 11.5547ZM6.8333 4.33333V3.66667H4.8333V4.33333H6.8333ZM8.49996 2H14.8333V0H8.49996V2ZM16.5 3.66667V13.3333H18.5V3.66667H16.5ZM14.8333 15H8.49996V17H14.8333V15ZM6.8333 13.3333V12.6667H4.8333V13.3333H6.8333ZM8.49996 15C8.01675 15 7.71448 14.9992 7.48673 14.9806C7.27065 14.963 7.21109 14.9344 7.1973 14.9273L6.28932 16.7094C6.63205 16.884 6.98411 16.9462 7.32387 16.974C7.65195 17.0008 8.04975 17 8.49996 17V15ZM4.8333 13.3333C4.8333 13.7835 4.83252 14.1813 4.85932 14.5094C4.88708 14.8492 4.94932 15.2012 5.12394 15.544L6.90596 14.636C6.89893 14.6222 6.87034 14.5626 6.85268 14.3466C6.83407 14.1188 6.8333 13.8165 6.8333 13.3333H4.8333ZM7.1973 14.9273C7.07186 14.8634 6.96987 14.7614 6.90596 14.636L5.12394 15.544C5.37961 16.0457 5.78755 16.4537 6.28932 16.7094L7.1973 14.9273ZM16.5 13.3333C16.5 13.8165 16.4992 14.1188 16.4806 14.3466C16.4629 14.5626 16.4343 14.6222 16.4273 14.636L18.2093 15.544C18.3839 15.2012 18.4462 14.8492 18.4739 14.5094C18.5007 14.1813 18.5 13.7835 18.5 13.3333H16.5ZM14.8333 17C15.2835 17 15.6813 17.0008 16.0094 16.974C16.3492 16.9462 16.7012 16.884 17.0439 16.7093L16.136 14.9273C16.1222 14.9344 16.0626 14.963 15.8465 14.9806C15.6188 14.9992 15.3165 15 14.8333 15V17ZM16.4273 14.636C16.3634 14.7614 16.2614 14.8634 16.136 14.9273L17.0439 16.7094C17.5457 16.4537 17.9537 16.0457 18.2093 15.544L16.4273 14.636ZM14.8333 2C15.3165 2 15.6188 2.00078 15.8465 2.01939C16.0626 2.03704 16.1222 2.06564 16.136 2.07266L17.0439 0.290649C16.7012 0.116021 16.3492 0.0537876 16.0094 0.026028C15.6813 -0.000777721 15.2835 0 14.8333 0V2ZM18.5 3.66667C18.5 3.21646 18.5007 2.81866 18.4739 2.49057C18.4462 2.15081 18.3839 1.79875 18.2093 1.45603L16.4273 2.36401C16.4343 2.3778 16.4629 2.43736 16.4806 2.65344C16.4992 2.88119 16.5 3.18346 16.5 3.66667H18.5ZM16.136 2.07266C16.2614 2.13658 16.3634 2.23856 16.4273 2.36401L18.2093 1.45603C17.9537 0.954261 17.5457 0.546312 17.0439 0.290649L16.136 2.07266ZM6.8333 3.66667C6.8333 3.18346 6.83407 2.88119 6.85268 2.65344C6.87034 2.43736 6.89893 2.3778 6.90596 2.36401L5.12394 1.45603C4.94932 1.79875 4.88708 2.15081 4.85932 2.49057C4.83252 2.81866 4.8333 3.21646 4.8333 3.66667H6.8333ZM8.49996 0C8.04975 0 7.65195 -0.000777721 7.32387 0.026028C6.98411 0.0537876 6.63205 0.116021 6.28932 0.290649L7.1973 2.07266C7.21109 2.06563 7.27065 2.03704 7.48673 2.01939C7.71448 2.00078 8.01675 2 8.49996 2V0ZM6.90596 2.36401C6.96987 2.23856 7.07186 2.13658 7.1973 2.07266L6.28932 0.290649C5.78755 0.546312 5.37961 0.95426 5.12394 1.45603L6.90596 2.36401ZM11.6666 7.5H2.49996V9.5H11.6666V7.5ZM2.50124 5.4453L0.988661 7.71418L2.65276 8.82358L4.16535 6.5547L2.50124 5.4453ZM0.988661 9.28583L2.50124 11.5547L4.16535 10.4453L2.65276 8.17642L0.988661 9.28583ZM0.988661 7.71417C0.671422 8.19003 0.671423 8.80997 0.988661 9.28583L2.65276 8.17642C2.78339 8.37237 2.78339 8.62763 2.65276 8.82358L0.988661 7.71417Z"
      fill="#252525"
    />
  </svg>
);

const GuideIcon = () => {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M15.027 2.52A14.17 14.17 0 0014 2.5H7.897v2.436c0 .956-.775.897-1.73.897h-2v9.834c0 .48 0 .79.02 1.027.018.226.05.31.07.351.08.157.208.284.365.364.04.021.125.053.351.071.236.02.547.02 1.027.02h8c.48 0 .79 0 1.027-.02.226-.018.31-.05.351-.07a.833.833 0 00.364-.365c.021-.041.053-.125.071-.352.02-.236.02-.546.02-1.026V4.333c0-.48 0-.79-.02-1.026-.018-.227-.05-.31-.07-.352a.833.833 0 00-.365-.364c-.04-.021-.125-.053-.351-.071zm-9.003-.991a2.5 2.5 0 011.73-.696h6.278c.44 0 .818 0 1.13.026.33.027.658.086.973.247a2.5 2.5 0 011.092 1.092c.161.316.22.643.247.973.026.312.026.691.026 1.13V15.7c0 .44 0 .818-.026 1.13-.026.33-.086.657-.247.973a2.5 2.5 0 01-1.092 1.092c-.315.16-.643.22-.973.247-.312.026-.69.026-1.13.026H5.968c-.44 0-.818 0-1.13-.026-.33-.027-.658-.086-.973-.247a2.5 2.5 0 01-1.093-1.092c-.16-.316-.22-.643-.247-.973-.025-.312-.025-.69-.025-1.13V5.69a2.5 2.5 0 01.732-1.767l.034-.034 2.758-2.36z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M10.333 7.475c-.851 0-1.542.69-1.542 1.542a.771.771 0 11-1.542 0 3.084 3.084 0 114.111 2.91.558.558 0 00-.222.138.177.177 0 00-.032.046l-.001.003v.001a.771.771 0 11-1.543 0c0-.896.72-1.444 1.285-1.643a1.543 1.543 0 00-.514-2.997zm-1.156 7.01a1.157 1.157 0 112.313 0 1.157 1.157 0 01-2.313 0z"
      clipRule="evenodd"
    ></path>
  </svg>
}

const SubMenuIcon = (props) => (
  <svg
    fill="none"
    width="20"
    height="20"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 3C.9 3 0 3.9 0 5v2c0 1.1.9 2 2 2h21c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 1h21c.563 0 1 .437 1 1v2c0 .563-.437 1-1 1H2c-.563 0-1-.437-1-1V5c0-.563.437-1 1-1zm0 17.5v2c0 .262.238.5.5.5h6.813l-1.157 1.125c-.48.497.28 1.157.688.72l2-2c.193-.187.193-.534 0-.72l-2-2c-.397-.397-1.14.268-.688.72L9.312 23H3v-1.5c0-.665-1-.644-1 0zm14-.5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm0 1h12c.563 0 1 .437 1 1v2c0 .563-.437 1-1 1H16c-.563 0-1-.437-1-1v-2c0-.563.437-1 1-1zM2 12c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h21c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm0 1h21c.563 0 1 .437 1 1v2c0 .563-.437 1-1 1H2c-.563 0-1-.437-1-1v-2c0-.563.437-1 1-1z"
      fill="#000000"
    />
  </svg>
);

const VoidIcon = () => (
  <svg
    fill="none"
    width="14"
    height="14"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  ></svg>
);

const SmartRosterIntigrationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.16669 16.3334L11.8334 1.66669M15.5 4.41669L18.9376 8.7137C19.0715 8.88109 19.0715 9.11895 18.9376 9.28634L15.5 13.5834M4.50002 4.41669L1.06241 8.7137C0.928497 8.88109 0.928497 9.11895 1.06241 9.28634L4.50002 13.5834"
      stroke="#68727D"
      strokeWidth="1.67"
      strokeLinecap="round"
    />
  </svg>
);
const SmartRosterIntigration = (props) => (
  <Icon {...props} component={SmartRosterIntigrationIcon} />
);

const RedflagIcon = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.17157 10H2V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V1.52839C0 0.684281 0.684282 0 1.52839 0H4.17157C6.2478 0 8.23899 0.824778 9.70711 2.29289C10.8001 3.38594 12.2826 4 13.8284 4H14.6477C15.3946 4 16 4.60543 16 5.35226V12.4067C16 13.2866 15.2866 14 14.4067 14H11.8284C9.7522 14 7.76101 13.1752 6.29289 11.7071C5.19985 10.6141 3.71737 10 2.17157 10Z"
      fill="#E33B32"
    />
  </svg>
);
const RedFlag = (props) => <Icon {...props} component={RedflagIcon} />;

const YellowflagIcon = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.17157 10H2V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V1.52839C0 0.684281 0.684282 0 1.52839 0H4.17157C6.2478 0 8.23899 0.824778 9.70711 2.29289C10.8001 3.38594 12.2826 4 13.8284 4H14.6477C15.3946 4 16 4.60543 16 5.35226V12.4067C16 13.2866 15.2866 14 14.4067 14H11.8284C9.7522 14 7.76101 13.1752 6.29289 11.7071C5.19985 10.6141 3.71737 10 2.17157 10Z"
      fill="#EFA22F"
    />
  </svg>
);
const YellowFlag = (props) => <Icon {...props} component={YellowflagIcon} />;

const GreenflagIcon = (props) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.17157 10H2V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V1.52839C0 0.684281 0.684282 0 1.52839 0H4.17157C6.2478 0 8.23899 0.824778 9.70711 2.29289C10.8001 3.38594 12.2826 4 13.8284 4H14.6477C15.3946 4 16 4.60543 16 5.35226V12.4067C16 13.2866 15.2866 14 14.4067 14H11.8284C9.7522 14 7.76101 13.1752 6.29289 11.7071C5.19985 10.6141 3.71737 10 2.17157 10Z"
      fill="#27b973"
    />
  </svg>
);
const GreenFlag = (props) => <Icon {...props} component={GreenflagIcon} />;

const GrayProgressBarIcon = (props) => (
  <svg
    width="144"
    height="8"
    viewBox="0 0 144 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H98C100.209 0 102 1.79086 102 4C102 6.20914 100.209 8 98 8H4C1.79086 8 0 6.20914 0 4Z"
      fill="#E5E5E7"
    />
  </svg>
);
const GrayProgressBar = (props) => (
  <Icon {...props} component={GrayProgressBarIcon} />
);

const YellowProgressBarIcon = (props) => (
  <svg
    width="214"
    height="8"
    viewBox="0 0 214 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H210C212.209 0 214 1.79086 214 4C214 6.20914 212.209 8 210 8H4C1.79086 8 0 6.20914 0 4Z"
      fill="url(#paint0_linear_440_55405)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_440_55405"
        x1="0"
        y1="4"
        x2="214"
        y2="4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF930F" />
        <stop offset="1" stop-color="#FFF95B" />
      </linearGradient>
    </defs>
  </svg>
);
const YellowProgressBar = (props) => (
  <Icon {...props} component={YellowProgressBarIcon} />
);

const BlueProgressBarIcon = (props) => (
  <svg
    width="214"
    height="8"
    viewBox="0 0 214 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H210C212.209 0 214 1.79086 214 4C214 6.20914 212.209 8 210 8H4C1.79086 8 0 6.20914 0 4Z"
      fill="url(#paint0_linear_440_55405)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_440_55405"
        x1="0"
        y1="4"
        x2="214"
        y2="4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF930F" />
        <stop offset="1" stop-color="#FFF95B" />
      </linearGradient>
    </defs>
  </svg>
);
const BlueProgressBar = (props) => (
  <Icon {...props} component={BlueProgressBarIcon} />
);

const PinkProgressBarIcon = (props) => (
  <svg
    width="179"
    height="8"
    viewBox="0 0 179 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H123C125.209 0 127 1.79086 127 4C127 6.20914 125.209 8 123 8H4C1.79086 8 0 6.20914 0 4Z"
      fill="#FFBEC7"
    />
  </svg>
);
const PinkProgressBar = (props) => (
  <Icon {...props} component={PinkProgressBarIcon} />
);

const PlaneUpAmIcon = (props) => (
  <div>
    <svg
      width="18"
      height="36"
      viewBox="0 0 18 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.07694 9.45924C2.07694 9.45924 5.38392 10.959 6.24255 10.6673C8.56971 9.87668 15.9824 7.35997 16.151 7.30299C17.0612 6.99456 17.5631 5.80635 17.4353 5.1997C17.3083 4.59305 16.4308 3.87152 15.4945 4.18769C15.4292 4.20937 13.6499 4.81199 11.3909 5.57626L4.56341 0.0411825C4.47251 -0.0266357 4.33421 -0.00867492 4.25504 0.080201L3.59482 0.900523C3.51663 0.990018 3.50295 1.15105 3.56599 1.25819L7.02177 7.05402C6.02044 7.3928 5.06749 7.71517 4.2504 7.9914L1.33046 5.6958C1.24568 5.62736 1.11715 5.64501 1.04458 5.73482L0.610865 6.27148C0.539028 6.36159 0.523389 6.52262 0.576901 6.63101C0.576901 6.63101 0.426873 6.4706 2.07694 9.45924ZM0 16.7613V18H18V16.7613H0Z"
        fill="#68727D"
      />
    </svg>
    <p className="Red-Flight-Icon">PM</p>
  </div>
);
const PlaneUpAm = (props) => <Icon {...props} component={PlaneUpAmIcon} />;

const PlaneUpAmGreenIcon = (props) => {

  const color = props.mode === "Day" ? "#1E8FFF" : "#35424A"
  return <div>
    <svg
      width="18"
      height="36"
      viewBox="0 0 18 36"
      fill={color ?? "#27B973"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.07694 9.45924C2.07694 9.45924 5.38392 10.959 6.24255 10.6673C8.56971 9.87668 15.9824 7.35997 16.151 7.30299C17.0612 6.99456 17.5631 5.80635 17.4353 5.1997C17.3083 4.59305 16.4308 3.87152 15.4945 4.18769C15.4292 4.20937 13.6499 4.81199 11.3909 5.57626L4.56341 0.0411825C4.47251 -0.0266357 4.33421 -0.00867492 4.25504 0.080201L3.59482 0.900523C3.51663 0.990018 3.50295 1.15105 3.56599 1.25819L7.02177 7.05402C6.02044 7.3928 5.06749 7.71517 4.2504 7.9914L1.33046 5.6958C1.24568 5.62736 1.11715 5.64501 1.04458 5.73482L0.610865 6.27148C0.539028 6.36159 0.523389 6.52262 0.576901 6.63101C0.576901 6.63101 0.426873 6.4706 2.07694 9.45924ZM0 16.7613V18H18V16.7613H0Z"
        fill={color ?? "#27B973"}
      />
    </svg>
    <p style={{ color: color ?? "#27B973",marginTop:-24,fontSize:10 }} className="Flight-Icon">
      {props?.shift}
    </p>
  </div>
};
const GreenPlaneUpAm = (props) => {
  return <Icon {...props} component={PlaneUpAmGreenIcon} />;
}

const RedPlaneUpAm = (props) => (
  <div >
    <svg
      width="18"
      height="36"
      viewBox="0 0 18 36"
      fill="#E33B32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.07694 9.45924C2.07694 9.45924 5.38392 10.959 6.24255 10.6673C8.56971 9.87668 15.9824 7.35997 16.151 7.30299C17.0612 6.99456 17.5631 5.80635 17.4353 5.1997C17.3083 4.59305 16.4308 3.87152 15.4945 4.18769C15.4292 4.20937 13.6499 4.81199 11.3909 5.57626L4.56341 0.0411825C4.47251 -0.0266357 4.33421 -0.00867492 4.25504 0.080201L3.59482 0.900523C3.51663 0.990018 3.50295 1.15105 3.56599 1.25819L7.02177 7.05402C6.02044 7.3928 5.06749 7.71517 4.2504 7.9914L1.33046 5.6958C1.24568 5.62736 1.11715 5.64501 1.04458 5.73482L0.610865 6.27148C0.539028 6.36159 0.523389 6.52262 0.576901 6.63101C0.576901 6.63101 0.426873 6.4706 2.07694 9.45924ZM0 16.7613V18H18V16.7613H0Z"
        fill="#E33B32"
      />
    </svg>
    {/* <p style={{color:"#E33B32",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p> */}
  </div>
);
// const RedPlaneUpAm = (props) => (
//   <Icon {...props} component={PlaneUpAmRedIcon} />
// );
const OrangePlaneUpAm = (props) => (
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="#FD7F20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07694 9.45924C2.07694 9.45924 5.38392 10.959 6.24255 10.6673C8.56971 9.87668 15.9824 7.35997 16.151 7.30299C17.0612 6.99456 17.5631 5.80635 17.4353 5.1997C17.3083 4.59305 16.4308 3.87152 15.4945 4.18769C15.4292 4.20937 13.6499 4.81199 11.3909 5.57626L4.56341 0.0411825C4.47251 -0.0266357 4.33421 -0.00867492 4.25504 0.080201L3.59482 0.900523C3.51663 0.990018 3.50295 1.15105 3.56599 1.25819L7.02177 7.05402C6.02044 7.3928 5.06749 7.71517 4.2504 7.9914L1.33046 5.6958C1.24568 5.62736 1.11715 5.64501 1.04458 5.73482L0.610865 6.27148C0.539028 6.36159 0.523389 6.52262 0.576901 6.63101C0.576901 6.63101 0.426873 6.4706 2.07694 9.45924ZM0 16.7613V18H18V16.7613H0Z"
      fill="#FD7F20"
    />
   
  </svg>
  <p style={{color:"#FD7F20",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p>
  </div>
);
// const OrangePlaneUpAm = (props) => (
//   <Icon {...props} component={OrangeUpAmRedIcon} />
// );

const YellowPlaneUpAm = (props) => (
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="#efa22f"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07694 9.45924C2.07694 9.45924 5.38392 10.959 6.24255 10.6673C8.56971 9.87668 15.9824 7.35997 16.151 7.30299C17.0612 6.99456 17.5631 5.80635 17.4353 5.1997C17.3083 4.59305 16.4308 3.87152 15.4945 4.18769C15.4292 4.20937 13.6499 4.81199 11.3909 5.57626L4.56341 0.0411825C4.47251 -0.0266357 4.33421 -0.00867492 4.25504 0.080201L3.59482 0.900523C3.51663 0.990018 3.50295 1.15105 3.56599 1.25819L7.02177 7.05402C6.02044 7.3928 5.06749 7.71517 4.2504 7.9914L1.33046 5.6958C1.24568 5.62736 1.11715 5.64501 1.04458 5.73482L0.610865 6.27148C0.539028 6.36159 0.523389 6.52262 0.576901 6.63101C0.576901 6.63101 0.426873 6.4706 2.07694 9.45924ZM0 16.7613V18H18V16.7613H0Z"
      fill="#efa22f"
    />
  </svg>
  <p style={{color:"#efa22f",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p>
  </div>
);
// const YellowPlaneUpAm = (props) => (
//   <Icon {...props} component={PlaneUpAmYellowIcon} />
// );

const PlaneDownPmIcon = (props) => (
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72517 9.10379C7.05256 9.79333 14.465 11.9898 14.6336 12.04C15.5438 12.3102 16.4472 11.6901 16.576 11.1611C16.7047 10.6318 16.2304 9.60176 15.2941 9.32346C15.2291 9.30347 13.45 8.77469 11.1923 8.10353L7.46355 0.145708C7.41151 0.0441139 7.28469 -0.0185716 7.18158 0.00493544L6.2858 0.260001C6.18269 0.284318 6.10768 0.398341 6.12014 0.513985L6.82556 6.80388C5.82521 6.50613 4.87226 6.2235 4.05517 5.98005L2.43295 2.63124C2.38677 2.53235 2.26826 2.47426 2.17053 2.50182L1.58263 2.66772C1.48538 2.69582 1.40792 2.8093 1.41134 2.92035C1.41134 2.92035 1.34513 2.71581 1.59509 5.88684C1.59485 5.88765 3.86653 8.84981 4.72517 9.10379ZM0 16.9192V18H18V16.9192H0Z"
      fill="#68727D"
    />
    <path
      d="M1.88068 31V23.7273H4.33807C4.90862 23.7273 5.375 23.8303 5.73722 24.0362C6.1018 24.2398 6.37169 24.5156 6.54688 24.8636C6.72206 25.2116 6.80966 25.5999 6.80966 26.0284C6.80966 26.4569 6.72206 26.8464 6.54688 27.1967C6.37405 27.5471 6.10653 27.8265 5.74432 28.0348C5.3821 28.2408 4.91809 28.3438 4.35227 28.3438H2.59091V27.5625H4.32386C4.71449 27.5625 5.02817 27.495 5.26491 27.3601C5.50166 27.2251 5.6733 27.0429 5.77983 26.8132C5.88873 26.5812 5.94318 26.3196 5.94318 26.0284C5.94318 25.7372 5.88873 25.4768 5.77983 25.2472C5.6733 25.0175 5.50047 24.8376 5.26136 24.7074C5.02225 24.5748 4.70502 24.5085 4.30966 24.5085H2.76136V31H1.88068ZM8.22834 23.7273H9.27947L11.7511 29.7642H11.8363L14.3079 23.7273H15.359V31H14.5352V25.4744H14.4641L12.1914 31H11.396L9.12322 25.4744H9.0522V31H8.22834V23.7273Z"
      fill="#68727D"
    />
  </svg>
);
const PlaneDownPm = (props) => <Icon {...props} component={PlaneDownPmIcon} />;

const GreenPlaneDownPmIcon = (props) => {
  const color = props?.mode === "Day" ? "#1E8FFF" : "#35424A"
return(
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill={color ?? "#27B973"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72517 9.10379C7.05256 9.79333 14.465 11.9898 14.6336 12.04C15.5438 12.3102 16.4472 11.6901 16.576 11.1611C16.7047 10.6318 16.2304 9.60176 15.2941 9.32346C15.2291 9.30347 13.45 8.77469 11.1923 8.10353L7.46355 0.145708C7.41151 0.0441139 7.28469 -0.0185716 7.18158 0.00493544L6.2858 0.260001C6.18269 0.284318 6.10768 0.398341 6.12014 0.513985L6.82556 6.80388C5.82521 6.50613 4.87226 6.2235 4.05517 5.98005L2.43295 2.63124C2.38677 2.53235 2.26826 2.47426 2.17053 2.50182L1.58263 2.66772C1.48538 2.69582 1.40792 2.8093 1.41134 2.92035C1.41134 2.92035 1.34513 2.71581 1.59509 5.88684C1.59485 5.88765 3.86653 8.84981 4.72517 9.10379ZM0 16.9192V18H18V16.9192H0Z"
      fill={color ?? "#27B973"}
    />
  
  </svg>
  <p style={{color:color ?? "#27B973",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p>
  </div>
);}
const GreenPlaneDownPm = (props) => (
  <Icon {...props} component={GreenPlaneDownPmIcon} />
);

const RedPlaneDownPm = (props) => (
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="#E33B32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72517 9.10379C7.05256 9.79333 14.465 11.9898 14.6336 12.04C15.5438 12.3102 16.4472 11.6901 16.576 11.1611C16.7047 10.6318 16.2304 9.60176 15.2941 9.32346C15.2291 9.30347 13.45 8.77469 11.1923 8.10353L7.46355 0.145708C7.41151 0.0441139 7.28469 -0.0185716 7.18158 0.00493544L6.2858 0.260001C6.18269 0.284318 6.10768 0.398341 6.12014 0.513985L6.82556 6.80388C5.82521 6.50613 4.87226 6.2235 4.05517 5.98005L2.43295 2.63124C2.38677 2.53235 2.26826 2.47426 2.17053 2.50182L1.58263 2.66772C1.48538 2.69582 1.40792 2.8093 1.41134 2.92035C1.41134 2.92035 1.34513 2.71581 1.59509 5.88684C1.59485 5.88765 3.86653 8.84981 4.72517 9.10379ZM0 16.9192V18H18V16.9192H0Z"
      fill="#E33B32"
    />
  </svg>
  {/* <p style={{color:"#E33B32",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p> */}
  </div>
);
// const RedPlaneDownPm = (props) => (
//   <Icon {...props} component={RedPlaneDownPmIcon} />
// );
const OrangePlaneDownPm = (props) => (
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="#FD7F20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72517 9.10379C7.05256 9.79333 14.465 11.9898 14.6336 12.04C15.5438 12.3102 16.4472 11.6901 16.576 11.1611C16.7047 10.6318 16.2304 9.60176 15.2941 9.32346C15.2291 9.30347 13.45 8.77469 11.1923 8.10353L7.46355 0.145708C7.41151 0.0441139 7.28469 -0.0185716 7.18158 0.00493544L6.2858 0.260001C6.18269 0.284318 6.10768 0.398341 6.12014 0.513985L6.82556 6.80388C5.82521 6.50613 4.87226 6.2235 4.05517 5.98005L2.43295 2.63124C2.38677 2.53235 2.26826 2.47426 2.17053 2.50182L1.58263 2.66772C1.48538 2.69582 1.40792 2.8093 1.41134 2.92035C1.41134 2.92035 1.34513 2.71581 1.59509 5.88684C1.59485 5.88765 3.86653 8.84981 4.72517 9.10379ZM0 16.9192V18H18V16.9192H0Z"
      fill="#FD7F20"
    />
  </svg>

<p style={{color:"#FD7F20",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p>
</div>
);
// const OrangePlaneDownPm = (props) => (
//   <Icon {...props} component={OrangePlaneDownPmIcon} />
// );

const YellowPlaneDownPm = (props) => (
  <div>
  <svg
    width="18"
    height="36"
    viewBox="0 0 18 36"
    fill="#efa22f"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72517 9.10379C7.05256 9.79333 14.465 11.9898 14.6336 12.04C15.5438 12.3102 16.4472 11.6901 16.576 11.1611C16.7047 10.6318 16.2304 9.60176 15.2941 9.32346C15.2291 9.30347 13.45 8.77469 11.1923 8.10353L7.46355 0.145708C7.41151 0.0441139 7.28469 -0.0185716 7.18158 0.00493544L6.2858 0.260001C6.18269 0.284318 6.10768 0.398341 6.12014 0.513985L6.82556 6.80388C5.82521 6.50613 4.87226 6.2235 4.05517 5.98005L2.43295 2.63124C2.38677 2.53235 2.26826 2.47426 2.17053 2.50182L1.58263 2.66772C1.48538 2.69582 1.40792 2.8093 1.41134 2.92035C1.41134 2.92035 1.34513 2.71581 1.59509 5.88684C1.59485 5.88765 3.86653 8.84981 4.72517 9.10379ZM0 16.9192V18H18V16.9192H0Z"
      fill="#efa22f"
    />
  </svg>


<p style={{color:"#efa22f",marginTop:-24,fontSize:10}} className="Flight-Icon">{props?.shift}</p>
</div>
);
// const YellowPlaneDownPm = (props) => (
//   <Icon {...props} component={YellowPlaneDownPmIcon} />
// );

const UserProfileIcon = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0003 18.3333C19.6027 18.3333 23.3337 14.6024 23.3337 9.99999C23.3337 5.39762 19.6027 1.66666 15.0003 1.66666C10.398 1.66666 6.66699 5.39762 6.66699 9.99999C6.66699 14.6024 10.398 18.3333 15.0003 18.3333ZM15.0003 18.3333C7.63653 18.3333 1.66699 22.8105 1.66699 28.3333M15.0003 18.3333C22.3641 18.3333 28.3337 22.8105 28.3337 28.3333"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const UserProfile = (props) => <Icon {...props} component={UserProfileIcon} />;

const FaviconIco = () => (
  <svg
    width="380"
    height="380"
    viewBox="0 0 380 380"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="380" height="380" rx="70" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M294.993 68.9721V113.461V325.5H85.0068V68.9721L155.432 68.9704C155.432 68.9704 164.251 46.5005 193.425 46.5005C222.598 46.5005 231.417 68.9704 231.417 68.9704L294.993 68.9721ZM119.687 103.722H260.313V290.82H119.687V103.722Z"
      fill="url(#paint0_linear_2406_7828)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M243.32 145.779L180.036 244.175L143.442 198.11L153.158 189.554L175.958 211.267L232.07 138.055L243.32 145.779Z"
      fill="url(#paint1_linear_2406_7828)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2406_7828"
        x1="189.94"
        y1="46.5007"
        x2="375.105"
        y2="185.472"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.478461" stop-color="#35424A" />
        <stop offset="1" stop-color="#CCFF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2406_7828"
        x1="193.353"
        y1="138.055"
        x2="266.555"
        y2="206.758"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.478461" stop-color="#35424A" />
        <stop offset="1" stop-color="#CCFF00" />
      </linearGradient>
    </defs>
  </svg>
);

const SvgCircle = (props) => (
  <svg
    {...props}
    width={10}
    height={10}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
  >
    <circle r="45" cx="50" cy="50" />
  </svg>
);

const IconDropdown = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 12"
    className={className}
    width={14}
  >
    <path
      id="Icon_ionic-ios-arrow-back"
      data-name="Icon ionic-ios-arrow-back"
      d="M3.617,11l7.942,8.318a1.619,1.619,0,0,1,0,2.22,1.458,1.458,0,0,1-2.125,0l-9-9.424A1.624,1.624,0,0,1,.393,9.948L9.429.458a1.46,1.46,0,0,1,2.125,0,1.619,1.619,0,0,1,0,2.22Z"
      transform="translate(0 12) rotate(-90)"
      fill={className || "#444444"}
    />
  </svg>
);

const CalendarIcon = (props) => (
  <svg
    {...props}
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V5.00016C17.5 4.07969 16.7538 3.3335 15.8333 3.3335Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.3335H17.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 1.66675V5.00008"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 1.66675V5.00008"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconThreeDots = ({ className, ...rest }) => (
  <svg
    width={20}
    height={20}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_2738_53474)">
      <path
        d="M10.3125 9.68731L10.3125 10.3123M9.68747 9.68731L9.68747 10.3123M10.3125 3.85397L10.3125 4.47897M9.68747 3.85397L9.68747 4.47897M10.3125 15.5206L10.3125 16.1456M9.68747 15.5206L9.68747 16.1456M9.99992 10.8333C9.53968 10.8333 9.16659 10.4602 9.16659 10C9.16659 9.53977 9.53968 9.16668 9.99992 9.16668C10.4602 9.16668 10.8333 9.53977 10.8333 10C10.8333 10.4602 10.4602 10.8333 9.99992 10.8333ZM9.99992 5.00001C9.53968 5.00001 9.16659 4.62691 9.16659 4.16668C9.16659 3.70644 9.53968 3.33334 9.99992 3.33334C10.4602 3.33334 10.8333 3.70644 10.8333 4.16668C10.8333 4.62691 10.4602 5.00001 9.99992 5.00001ZM9.99992 16.6667C9.53968 16.6667 9.16659 16.2936 9.16659 15.8333C9.16659 15.3731 9.53968 15 9.99992 15C10.4602 15 10.8333 15.3731 10.8333 15.8333C10.8333 16.2936 10.4602 16.6667 9.99992 16.6667Z"
        stroke="black"
        strokeOpacity="0.56"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2738_53474">
        <path
          d="M14 -2.62268e-07C17.3137 -1.17422e-07 20 2.68629 20 6L20 14C20 17.3137 17.3137 20 14 20L6 20C2.68629 20 -7.56806e-07 17.3137 -6.11959e-07 14L-2.62268e-07 6C-1.17422e-07 2.68629 2.68629 -7.56806e-07 6 -6.11959e-07L14 -2.62268e-07Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

const WorkmateShareIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke={props?.stroke ?? "#35424A"}
        strokeLinecap="round"
        strokeWidth="2"
        d="M14 2L6.28 9.116a.375.375 0 00-.12.276v4.344c0 .348.432.509.659.244l3.022-3.525m-7.72-2.89l12.068-6.034a.375.375 0 01.543.346l-.275 9.326a.375.375 0 01-.475.35L2.187 8.262a.375.375 0 01-.067-.697z"
      ></path>
    </svg>
  );
};
const WorkmateCalenderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 18"
      {...props}
    >
      <path
        stroke={props?.stroke ?? "#35424A"}
        strokeLinecap="round"
        strokeWidth="2"
        d="M8 7.5L5.588 9.688a.252.252 0 01-.332 0L4.25 8.775M8.75 12h3M5 4.5v-3m6 3v-3m-4.95 15h3.9c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311c.327-.642.327-1.482.327-3.162V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C12.47 3 11.63 3 9.95 3h-3.9c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C1.25 5.28 1.25 6.12 1.25 7.8v3.9c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311c.642.327 1.482.327 3.162.327z"
      ></path>
    </svg>
  );
};
const WorkmateAccIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke={props?.stroke ?? "#35424A"}
        strokeLinecap="round"
        strokeWidth="2"
        d="M2 6.5v0a.87.87 0 01-.756-1.302l1.5-2.625c.175-.306.262-.458.366-.586a2 2 0 011.223-.71c.163-.027.339-.027.69-.027H6.5M2 6.5v5.05c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.428.218.988.218 2.108.218H8M2 6.5h3m9 0v0a.87.87 0 00.756-1.302l-1.5-2.625c-.175-.306-.262-.458-.366-.586a2 2 0 00-1.224-.71c-.162-.027-.338-.027-.69-.027H9.5M14 6.5v5.25c0 .932 0 1.398-.152 1.765a2 2 0 01-1.083 1.083c-.367.152-.833.152-1.765.152v0m3-8.25h-3m0 8.25H8m3 0V11c0-.466 0-.699-.076-.883a1 1 0 00-.541-.54C10.199 9.5 9.966 9.5 9.5 9.5v0c-.466 0-.699 0-.883.076a1 1 0 00-.54.541C8 10.301 8 10.534 8 11v3.75M5 9.5v.008M5 6.5h6m-6 0l1.5-5.25m0 0h3m0 0L11 6.5"
      ></path>
    </svg>
  );
};
const DownloadIcon = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.99998 0.333252C7.36817 0.333252 7.66665 0.631729 7.66665 0.999919V8.05711L9.19524 6.52851C9.45559 6.26816 9.8777 6.26816 10.1381 6.52851C10.3984 6.78886 10.3984 7.21097 10.1381 7.47132L7.94279 9.66659C7.42209 10.1873 6.57787 10.1873 6.05717 9.66659L3.86191 7.47132C3.60156 7.21097 3.60156 6.78886 3.86191 6.52851C4.12226 6.26817 4.54437 6.26817 4.80472 6.52851L6.33331 8.05711V0.999919C6.33331 0.631729 6.63179 0.333252 6.99998 0.333252Z"
      fill="black"
    />
    <path
      d="M1.66665 9.66659C1.66665 9.2984 1.36817 8.99992 0.99998 8.99992C0.631791 8.99992 0.333313 9.2984 0.333313 9.66659V9.82745C0.333305 10.3641 0.333298 10.807 0.362776 11.1678C0.393393 11.5425 0.459102 11.887 0.623963 12.2106C0.879625 12.7123 1.28757 13.1203 1.78934 13.3759C2.1129 13.5408 2.45736 13.6065 2.8321 13.6371C3.19289 13.6666 3.6358 13.6666 4.17245 13.6666H9.82751C10.3642 13.6666 10.8071 13.6666 11.1679 13.6371C11.5426 13.6065 11.8871 13.5408 12.2106 13.3759C12.7124 13.1203 13.1203 12.7123 13.376 12.2106C13.5409 11.887 13.6066 11.5425 13.6372 11.1678C13.6667 10.807 13.6667 10.3641 13.6666 9.82747V9.66659C13.6666 9.2984 13.3682 8.99992 13 8.99992C12.6318 8.99992 12.3333 9.2984 12.3333 9.66659V9.79992C12.3333 10.371 12.3328 10.7592 12.3083 11.0592C12.2844 11.3515 12.2411 11.501 12.188 11.6052C12.0602 11.8561 11.8562 12.0601 11.6053 12.1879C11.501 12.2411 11.3516 12.2843 11.0593 12.3082C10.7592 12.3327 10.371 12.3333 9.79998 12.3333H4.19998C3.62893 12.3333 3.24073 12.3327 2.94067 12.3082C2.6484 12.2843 2.49893 12.2411 2.39466 12.1879C2.14378 12.0601 1.9398 11.8561 1.81197 11.6052C1.75885 11.501 1.71556 11.3515 1.69168 11.0592C1.66717 10.7592 1.66665 10.371 1.66665 9.79992V9.66659Z"
      fill="black"
    />
  </svg>
);

const EditIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.33763 11.9954L2.97009 12.2063V12.2063L2.33763 11.9954ZM2.95469 10.1443L2.32223 9.93346H2.32223L2.95469 10.1443ZM3.59139 9.11407L4.0628 9.58547L4.0628 9.58547L3.59139 9.11407ZM9.74052 2.96495L9.26911 2.49354V2.49354L9.74052 2.96495ZM13.0351 6.25948L13.5065 6.73089L13.0351 6.25948ZM6.88593 12.4086L6.41453 11.9372H6.41453L6.88593 12.4086ZM5.85572 13.0453L6.06654 13.6778H6.06654L5.85572 13.0453ZM4.00455 13.6624L4.21537 14.2948H4.21537L4.00455 13.6624ZM6.5482 12.7238L6.14671 12.1916L6.14671 12.1916L6.5482 12.7238ZM6.2887 12.8842L5.99223 12.2871L6.2887 12.8842ZM13.8287 3.8808L13.2314 4.17681L13.2314 4.17681L13.8287 3.8808ZM13.8287 5.34363L13.2314 5.04762L13.2314 5.04762L13.8287 5.34363ZM10.6564 2.17128L10.9524 2.76863L10.9524 2.76863L10.6564 2.17128ZM12.1192 2.17128L11.8232 2.76863L11.8232 2.76863L12.1192 2.17128ZM3.11578 9.7113L3.7129 10.0078L3.7129 10.0078L3.11578 9.7113ZM3.27617 9.45179L2.74396 9.0503L2.74396 9.0503L3.27617 9.45179ZM2.03067 13.4702L1.40273 13.6941L2.03067 13.4702ZM2.52981 13.9693L2.30589 14.5973H2.30589L2.52981 13.9693ZM9.38828 3.3172C9.12793 3.05686 8.70582 3.05686 8.44547 3.3172C8.18512 3.57755 8.18512 3.99966 8.44547 4.26001L9.38828 3.3172ZM11.74 7.55455C12.0004 7.8149 12.4225 7.8149 12.6828 7.55455C12.9432 7.2942 12.9432 6.87209 12.6828 6.61174L11.74 7.55455ZM2.97009 12.2063L3.58714 10.3551L2.32223 9.93346L1.70518 11.7846L2.97009 12.2063ZM4.0628 9.58547L10.2119 3.43635L9.26911 2.49354L3.11999 8.64266L4.0628 9.58547ZM12.5636 5.78808L6.41453 11.9372L7.35733 12.88L13.5065 6.73089L12.5636 5.78808ZM5.6449 12.4129L3.79373 13.0299L4.21537 14.2948L6.06654 13.6778L5.6449 12.4129ZM6.41453 11.9372C6.23786 12.1139 6.19276 12.1569 6.14671 12.1916L6.9497 13.256C7.08685 13.1526 7.20584 13.0315 7.35734 12.88L6.41453 11.9372ZM6.06654 13.6778C6.26979 13.61 6.43129 13.5577 6.58517 13.4813L5.99223 12.2871C5.94056 12.3127 5.88192 12.3338 5.6449 12.4129L6.06654 13.6778ZM6.14671 12.1916C6.09828 12.2282 6.04657 12.2601 5.99223 12.2871L6.58517 13.4813C6.71339 13.4177 6.83542 13.3423 6.9497 13.256L6.14671 12.1916ZM12.5636 3.43635C13.0508 3.9235 13.1722 4.05733 13.2314 4.17681L14.4261 3.58479C14.2452 3.21982 13.9175 2.90457 13.5065 2.49354L12.5636 3.43635ZM13.5065 6.73089C13.9175 6.31986 14.2452 6.00461 14.4261 5.63964L13.2314 5.04762C13.1722 5.1671 13.0508 5.30093 12.5636 5.78808L13.5065 6.73089ZM13.2314 4.17681C13.3673 4.45116 13.3673 4.77327 13.2314 5.04762L14.4261 5.63964C14.7469 4.99225 14.7469 4.23218 14.4261 3.58479L13.2314 4.17681ZM10.2119 3.43635C10.6991 2.94921 10.8329 2.82784 10.9524 2.76863L10.3604 1.57394C9.99539 1.7548 9.68013 2.08252 9.26911 2.49354L10.2119 3.43635ZM13.5065 2.49354C13.0954 2.08252 12.7802 1.7548 12.4152 1.57394L11.8232 2.76863C11.9427 2.82784 12.0765 2.9492 12.5636 3.43635L13.5065 2.49354ZM10.9524 2.76863C11.2267 2.63268 11.5488 2.63268 11.8232 2.76863L12.4152 1.57394C11.7678 1.25313 11.0077 1.25313 10.3604 1.57394L10.9524 2.76863ZM3.58714 10.3551C3.66615 10.1181 3.68725 10.0594 3.7129 10.0078L2.51867 9.41483C2.44226 9.56871 2.38998 9.73021 2.32223 9.93346L3.58714 10.3551ZM3.11999 8.64266C2.96849 8.79416 2.84743 8.91314 2.74396 9.0503L3.80838 9.85329C3.84312 9.80724 3.88614 9.76213 4.0628 9.58547L3.11999 8.64266ZM3.7129 10.0078C3.73988 9.95343 3.77184 9.90172 3.80838 9.85329L2.74396 9.0503C2.65775 9.16458 2.58233 9.28661 2.51867 9.41483L3.7129 10.0078ZM1.70518 11.7846C1.57525 12.1744 1.46254 12.5104 1.39878 12.7818C1.33735 13.0432 1.28739 13.3707 1.40273 13.6941L2.6586 13.2463C2.67852 13.3021 2.64792 13.2946 2.69676 13.0868C2.74328 12.8888 2.83176 12.6213 2.97009 12.2063L1.70518 11.7846ZM3.79373 13.0299C3.37874 13.1682 3.11119 13.2567 2.91323 13.3032C2.70538 13.3521 2.69788 13.3215 2.75373 13.3414L2.30589 14.5973C2.62933 14.7126 2.95681 14.6627 3.21824 14.6012C3.48956 14.5375 3.82559 14.4247 4.21537 14.2948L3.79373 13.0299ZM1.40273 13.6941C1.55298 14.1155 1.88455 14.447 2.30589 14.5973L2.75373 13.3414C2.70935 13.3256 2.67443 13.2906 2.6586 13.2463L1.40273 13.6941ZM8.44547 4.26001L11.74 7.55455L12.6828 6.61174L9.38828 3.3172L8.44547 4.26001Z"
      fill="black"
    />
  </svg>
);

const DeletIcon = ({ svgClasses }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      className={svgClasses}
      fill="none"
      viewBox="0 0 13 16"
    >
      <path
        fill="#fff"
        d="M11.095 12.024l1 .009-1-.009zM1.167 3a1 1 0 000 2V3zm10.666 2a1 1 0 100-2v2zM6.167 6.667a1 1 0 10-2 0h2zm-2 5.333a1 1 0 002 0h-2zm4.666-5.333a1 1 0 10-2 0h2zm-2 5.333a1 1 0 002 0h-2zm3.334-8.009l-.072 8.024 2 .018.072-8.024-2-.018zm-1.739 9.676H4.5v2h3.928v-2zM.833 4v8h2V4h-2zm.334 1h.666V3h-.666v2zm.666 0h2V3h-2v2zm2 0h5.334V3H3.833v2zm5.334 0h2V3h-2v2zm2 0h.666V3h-.666v2zM4.833 3.704c0-.65.633-1.37 1.667-1.37v-2c-1.911 0-3.667 1.401-3.667 3.37h2zM6.5 2.334c1.034 0 1.667.72 1.667 1.37h2c0-1.969-1.756-3.37-3.667-3.37v2zm-3.667 1.37V4h2v-.296h-2zm5.334 0V4h2v-.296h-2zM4.5 13.667c-.92 0-1.667-.746-1.667-1.667h-2A3.667 3.667 0 004.5 15.667v-2zm5.595-1.652a1.667 1.667 0 01-1.667 1.652v2a3.667 3.667 0 003.667-3.634l-2-.018zM4.167 6.667V12h2V6.667h-2zm2.666 0V12h2V6.667h-2z"
      ></path>
    </svg>
  );
};
const FlightOutIcon = (props) => (
  <svg
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.3334 2.16658L6.8977 10.8638C6.80355 10.9505 6.75 11.0727 6.75 11.2008V16.5109C6.75 16.9364 7.2794 17.1323 7.55633 16.8092L11.25 12.4999M1.81356 8.96813L16.5644 1.59273C16.8744 1.43772 17.2377 1.66968 17.2275 2.01616L16.8922 13.4145C16.8835 13.7121 16.5977 13.9225 16.3109 13.8425L1.89534 9.81954C1.49139 9.70681 1.43845 9.15569 1.81356 8.96813Z"
      stroke="#35424A"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const FaviconSiteIcon = (props) => <Icon component={FaviconIco} {...props} />;

const UserIcon = (props) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.29545 4.29545C9.29545 5.39958 8.75246 6.37688 7.91894 6.97488C8.50427 7.16194 9.03572 7.43288 9.48685 7.77123C10.3955 8.45273 11 9.42891 11 10.5455C11 10.7965 10.7965 11 10.5455 11H1.45455C1.20351 11 1 10.7965 1 10.5455C1 9.42891 1.60448 8.45273 2.51315 7.77123C2.96428 7.43288 3.49573 7.16194 4.08106 6.97488C3.24754 6.37688 2.70455 5.39958 2.70455 4.29545C2.70455 2.47543 4.17997 1 6 1C7.82003 1 9.29545 2.47543 9.29545 4.29545Z"
      fill="black"
    />
  </svg>
);

const FlightInIcon = (props) => (
  <svg
    width={22}
    height={17}
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.2655 8.24641L6.57971 6.31177C6.45314 6.29247 6.32426 6.32699 6.22429 6.40697L2.07784 9.72428C1.74557 9.99011 1.92338 10.5258 2.34865 10.5402L8.02106 10.7324M4.88381 1.15757L19.8579 8.06829C20.1727 8.21354 20.2185 8.6421 19.9416 8.85059L10.8317 15.7095C10.5938 15.8886 10.251 15.7969 10.1343 15.5229L4.27007 1.75331C4.10574 1.36746 4.50302 0.981829 4.88381 1.15757Z"
      stroke="#35424A"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const HouseIcon = (props) => (
  <svg
    width={22}
    height={23}
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.66667 9.66667V9.66667C2.84976 9.66667 2.33762 8.78416 2.74292 8.07489L4.57865 4.86236C4.91422 4.27512 5.082 3.9815 5.31776 3.76789C5.52635 3.57889 5.77249 3.43605 6.04007 3.34871C6.34251 3.25 6.68068 3.25 7.35703 3.25H9.16667M3.66667 9.66667V16.55C3.66667 17.6701 3.66667 18.2302 3.88465 18.658C4.0764 19.0343 4.38236 19.3403 4.75869 19.532C5.18651 19.75 5.74656 19.75 6.86667 19.75H11M3.66667 9.66667H7.33333M18.3333 9.66667V9.66667C19.1502 9.66667 19.6624 8.78416 19.2571 8.07489L17.4213 4.86236C17.0858 4.27512 16.918 3.9815 16.6822 3.76789C16.4737 3.57889 16.2275 3.43605 15.9599 3.34871C15.6575 3.25 15.3193 3.25 14.643 3.25H12.8333M18.3333 9.66667V16.55C18.3333 17.6701 18.3333 18.2302 18.1153 18.658C17.9236 19.0343 17.6176 19.3403 17.2413 19.532C16.8135 19.75 16.2534 19.75 15.1333 19.75H14.6667M18.3333 9.66667H14.6667M14.6667 19.75H11M14.6667 19.75V14.9333C14.6667 14.3733 14.6667 14.0933 14.5577 13.8793C14.4618 13.6912 14.3088 13.5382 14.1207 13.4423C13.9067 13.3333 13.6267 13.3333 13.0667 13.3333H12.6C12.0399 13.3333 11.7599 13.3333 11.546 13.4423C11.3578 13.5382 11.2049 13.6912 11.109 13.8793C11 14.0933 11 14.3733 11 14.9333V19.75M7.33333 13.3333V13.3425M7.33333 9.66667H11H14.6667M7.33333 9.66667L9.16667 3.25M9.16667 3.25H12.8333M12.8333 3.25L14.6667 9.66667"
      stroke="#35424A"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const CrossIcon = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill="black"
      fillOpacity={0.56}
    />
  </svg>
);
// const CarIcon = (props) => <Icon {...props} component={CarIconButton} />;


const CarIcon = ({ mode = "day" }) => {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="15"
    fill="none"
    viewBox="0 0 22 15"
  >
    <path
      fill={mode === "day" ? "#1E8FFF" : "#35424A"}
      fillRule="evenodd"
      d="M10.083 2.5v3.667h5.145l-1.013-3.04a.917.917 0 00-.87-.627h-3.262zm7.078 3.667l-1.207-3.62a2.75 2.75 0 00-2.609-1.88H6.821a2.75 2.75 0 00-2.609 1.88L3.215 5.54c-.05.15-.17.317-.425.545a9.014 9.014 0 01-.43.351l-.022.018c-.15.118-.323.253-.486.397a2.746 2.746 0 00-.935 2.066v.916c0 1.241.822 2.29 1.95 2.633a2.751 2.751 0 005.226.117h5.813a2.751 2.751 0 005.226-.117 2.751 2.751 0 001.951-2.633v-.916a2.75 2.75 0 00-2.75-2.75h-1.172zM5.5 10.75a.917.917 0 100 1.833.917.917 0 000-1.833zm11.917.917a.917.917 0 10-1.834 0 .917.917 0 001.834 0z"
      clipRule="evenodd"
    ></path>
  </svg>
}

export {
  ProfileDots,
  SmartRosterTaskCenter,
  SmartRosterPinned,
  SmartRosterActivity,
  SmartRosterDashboard,
  SmartRosterAdd,
  SmartRosterNewmanTanks,
  SmartRosterBHP,
  SmartRosterPersonnel,
  SmartRosterFlights,
  MettingAccomodation,
  SmartRosterReports,
  SmartRosterSetting,
  SmartRosterManagement,
  SmartRosterData,
  SmartRosterIntigration,
  SmartRosterArrows,
  RedFlag,
  YellowFlag,
  GreenFlag,
  GrayProgressBar,
  YellowProgressBar,
  BlueProgressBar,
  PinkProgressBar,
  PlaneUpAm,
  GreenPlaneUpAm,
  GreenPlaneDownPmIcon,
  PlaneUpAmGreenIcon,
  PlaneDownPm,
  UserProfile,
  RedPlaneUpAm,
  YellowPlaneUpAm,
  GreenPlaneDownPm,
  RedPlaneDownPm,
  OrangePlaneDownPm,
  OrangePlaneUpAm,
  YellowPlaneDownPm,
  FaviconSiteIcon,
  SvgCircle,
  IconDropdown,
  CalendarIcon,
  IconThreeDots,
  WorkmateShareIcon,
  WorkmateCalenderIcon,
  WorkmateAccIcon,
  DownloadIcon,
  EditIcon,
  LogoutIcon,
  SubMenuIcon,
  VoidIcon,
  SearchIcon,
  DeletIcon,
  FlightOutIcon,
  UserIcon,
  FlightInIcon,
  HouseIcon,
  CrossIcon,
  CarIcon,
  GuideIcon,
};
